import React from 'react';
import { styled } from '@linaria/react';

import useBoundingBox from '@/hooks/use-bounding-box';
import useSound from '@/hooks/use-sound';

import SouvlakiPieceStatic from './SouvlakiPieceStatic';
import SouvlakiPieceDraggable from './SouvlakiPieceDraggable';

function SouvlakiDemo() {
  const [status, setStatus] = React.useState('fine');

  const [play, { stop }] = useSound('/sounds/wrong.mp3', {
    volume: 0.5,
  });

  const firstPieceRef = React.useRef();
  const thirdPieceRef = React.useRef();

  const firstBB = useBoundingBox(firstPieceRef);
  const thirdBB = useBoundingBox(thirdPieceRef);

  function handleIntersect(side) {
    setStatus(`intersecting-${side}`);
    stop();
    play();
  }

  function handleClear() {
    setStatus('fine');
  }

  return (
    <Wrapper>
      <StickOutline
        alt=""
        src="/images/interactive-guide-to-flexbox/souvlaki-stick-white.png"
      />
      <SouvlakiPieceStatic
        ref={firstPieceRef}
        status={
          status === 'intersecting-left' ? 'intersecting' : 'fine'
        }
        index={1}
        left="15%"
      />
      <SouvlakiPieceDraggable
        index={2}
        left="36%"
        status={status}
        firstBB={firstBB}
        thirdBB={thirdBB}
        handleIntersect={handleIntersect}
        handleClear={handleClear}
      />
      <SouvlakiPieceStatic
        ref={thirdPieceRef}
        status={
          status === 'intersecting-right' ? 'intersecting' : 'fine'
        }
        index={3}
        left="58%"
      />
      <picture>
        <source
          type="image/avif"
          srcSet="/images/interactive-guide-to-flexbox/souvlaki-stick-front.avif"
        />
        <source
          type="image/png"
          srcSet="/images/interactive-guide-to-flexbox/souvlaki-stick-front.png"
        />
        <Stick
          alt=""
          src="/images/interactive-guide-to-flexbox/souvlaki-stick-front.png"
        />
      </picture>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  isolation: isolate;
  position: relative;
  width: fit-content;
  margin: 32px auto 48px;
`;

const ToggleWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  top: -32px;
  right: 16px;
`;

const StickOutline = styled.img`
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  max-width: 732px;
`;

const Stick = styled.img`
  display: block;
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 100%;
  inset: 0px;
`;

export default SouvlakiDemo;
